import script from "./HeroVideoBlock.vue?vue&type=script&setup=true&lang=js"
export * from "./HeroVideoBlock.vue?vue&type=script&setup=true&lang=js"

import "./HeroVideoBlock.vue?vue&type=style&index=0&id=1e013a14&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1e013a14"]])

export default __exports__